import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { ForgotPasswordForm } from "../../organisms/form/ForgotPasswordForm";
import { useForgotPassword } from "./hook";

export const ForgotPassword: React.FC = () => {
  const { handleForgotPassword } = useForgotPassword();

  return (
    <Container>
      <TitleWrapper>パスワードをお忘れの方</TitleWrapper>

      <Message>
        ご登録いただいたメールアドレスを入力していただき、｢送信｣ボタンをクリックしてください。ご登録メールアドレスに、パスワード変更URLを送信いたします。
      </Message>
      <Message>※印は必須項目です。</Message>

      <ForgotPasswordForm handleSubmit={handleForgotPassword} />
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  padding: 0 16px;
  margin: 0 auto 80px;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleWrapper = styled.p`
  font-size: 20px;
  font-weight: 600;
  padding: 43px 0 38px;
  display: flex;
  line-height: 1em;
  font-family: "Hiragino Sans";
  justify-content: center;
`;

const Message = styled.p`
  font-size: 14px;
  color: ${BASIC_DARK_GRAY};
  font-weight: 300;
  margin-bottom: 26px;
  text-align: left;
  font-family: "Hiragino Sans";
`;
